import { render } from "./InventoryItemStats.vue?vue&type=template&id=61132296"
import script from "./InventoryItemStats.vue?vue&type=script&lang=js"
export * from "./InventoryItemStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__